<div class="comp-grid-cell flex-fill" (click)="value.hasRule ? onFieldSelected() : null"
    [ngClass]="{'canSelectField': value.hasRule}">
    <div *ngIf="!value.hasTwoValues" class="adjust-item-not-array py-3 highlight" [ngClass]="highlightType">
        <i class="fa fa-check" *ngIf="value.value === 'Yes' || value.value[0] === 'Yes'"></i>
        <i class="fa fa-times" *ngIf="value.value === 'No' || value.value[0] === 'No'"></i>
        {{value.value}}
    </div>

    <div *ngIf="value.hasTwoValues" class="row">
        <div class="col adjust-item-in-array py-3 highlight" [ngClass]="highlightType">
            <i class="fa fa-check" *ngIf="value.value[0] === 'Yes'"></i>
            <i class="fa fa-times" *ngIf="value.value[0] === 'No'"></i>
            {{value.value[0]}}
        </div>
        <div class="col-6 py-3 comp-grid-cell__adjustment highlight" [ngClass]="highlightType">
            {{value.value[1]}}
        </div>
    </div>
</div>